import { Dialog, DialogContent, DialogTitle, DialogContentText, DialogActions, Button as MUIButton } from '@mui/material';
import styled from 'styled-components';

export const Container = styled(Dialog)``;

export const Title = styled(DialogTitle)`
    font-size: 1rem;
    padding: 0.8rem;
    width: 100%;
    border-bottom: 1px;
    color: var(--color-primary);
    font-weight: 700;
    text-align: center;
`;

export const Line = styled.div`
    width: 80%;
    margin: 0 auto;
    height: 1px;
    background-color: #c7c7c7;
`;

export const Content = styled(DialogContent)`
    padding: 0.8rem;
`;

export const Text = styled(DialogContentText)`
    font-size: 0.9rem;
`;

export const Actions = styled(DialogActions)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const Button = styled(MUIButton)`
    width: auto;
    font-size: 0.8rem;
    text-transform: none;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: ${({ cancel }) => (cancel ? '#E2EDD0' : 'var(--color-secondary)')};
    color: ${({ cancel }) => (cancel ? 'var(--color-primary)' : '#fff')};

    &:hover {
        background-color: var(--color-primary);
        color: #fff;
    }
`;
